module.exports = __webpack_public_path__ + "img/5.a2f16a11.webp";